import type { ReactNode } from "react";
import { cn } from "@design-lab/shared/lib";
import { DateValueText } from "./DateValueText";
import type { DeliveryDateInfo } from "../model/HeaderModes";

export interface DeliveryDateValueCallbackProps {
  valueElement: ReactNode;
  timeRange: string | undefined;
  formattedTimeLeft: string | undefined;
}

export type DeliveryDateValueProps = {
  className?: string | undefined;
  children?: ((props: DeliveryDateValueCallbackProps) => React.ReactNode) | undefined;
  deliveryDateInfo: DeliveryDateInfo;
};

export function DeliveryDateValue(props: DeliveryDateValueProps) {
  const { className, children, deliveryDateInfo } = props;

  const valueElement = (
    <DateValueText dateValue={deliveryDateInfo.timeRange || deliveryDateInfo.valueFull} />
  );

  if (children) {
    return children({
      valueElement,
      timeRange: deliveryDateInfo.timeRange,
      formattedTimeLeft: deliveryDateInfo.formattedTimeLeft
    });
  }

  return (
    <div>
      <p className={cn("text-xl", className)}>
        <span>Get it</span> <span className="text-default-blue-600 font-bold">{valueElement}</span>
      </p>
      <p className="text-center text-xs font-bold">
        <span className="text-default-blue-600">No Sneaky Rush Fees!</span>{" "}
      </p>
    </div>
  );
}
